import { gql } from '@apollo/client';

export const GET_MATCHING_CANDIDATES = gql`
  query GetMatchingCandidates($roleId: String!) {
    vm {
      matchingCandidates(roleId: $roleId) {
        applicationId
        name
        email
        status
        dateSubmitted
        profile {
          profileId
          preferredName
          lastName
          dateOfBirth
          simpleAvailability {
            simpleAvailabilityId
            mondayAm
            mondayPm
            tuesdayAm
            tuesdayPm
            wednesdayAm
            wednesdayPm
            thursdayAm
            thursdayPm
            fridayAm
            fridayPm
            saturdayAm
            saturdayPm
            sundayAm
            sundayPm
          }
        }
        applicationRoles {
          applicationRoleId
          role {
            activityRoleId
            name
          }
          status
        }
        funnel {
          name
        }
      }
    }
  }
`;

export const GET_APPLICANT_AVAILABILITY = gql`
  query GetApplicantAvailability($profileId: String!) {
    vm {
      profile(profileId: $profileId) {
        simpleAvailability {
          simpleAvailabilityId
          mondayAm
          mondayPm
          tuesdayAm
          tuesdayPm
          wednesdayAm
          wednesdayPm
          thursdayAm
          thursdayPm
          fridayAm
          fridayPm
          saturdayAm
          saturdayPm
          sundayAm
          sundayPm
        }
      }
    }
  }
`;
